import React, { useState } from 'react';
import { PiPrinterLight } from "react-icons/pi";
import { useTranslation } from 'react-i18next';
import API from 'api';
import { file, swalAlert } from 'utils';
import { transform } from 'lodash';
const TreePrint = ({
  item,
  disabled = false,
  label = '',
  btnClassName = 'btn btn-sm btn-outline-primary',
  iconSize = 16
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const Tag = btnClassName.includes('btn') ? 'button' : 'span';
  const handlePrint = async () => {
    if (disabled) {
      return;
    }
    setLoading(true);
    const params = {
      entity: "project",
      id: item.itProjId,
      type: "sheet",
      scope: "item",
      pictures: "all",
      itemId: item.itId
    };
    try {
      const response = await API.post(`/export`, { ...params });
      if (response.data.output_file) {
        const fileUrl = await file(response.data.output_file);
        window.open(fileUrl, '_blank'); // Ouvre le fichier exporté
      }
    } catch (error) {
      swalAlert(t(error.response.data.error.message));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tag
      className={`treePrint ${btnClassName} ${label ? 'me-2' : ''}`} // Concaténation classique
      onClick={handlePrint}
      disabled={Tag === 'button' ? disabled || loading : undefined} // Désactiver si c'est un bouton
    >
      <PiPrinterLight
        size={iconSize}
        className={label ? 'me-2' : ''} // Ajoute la marge uniquement si label existe
        style={Tag === 'button' ? { transform: 'translateY(-3px)' } : undefined} // Décale seulement si c'est un bouton
      />
      {label}
    </Tag>
  );
};
export default TreePrint;
